/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useState } from 'react';
import MeasurementUnits from '../../../Layout/MeasurementUnits';
import { useAppContext } from '@front-activerse/common-components';
import { Loader } from '@front-activerse/common-components';

const DayPlanIngredientReplacement = ({
  name,
  measurements,
  replacementId,
  productAmountId,
  productKey,
  replaceProduct,
  replaceProductSuccess,
}) => {
  const [preloadInside, setPreloadInside] = useState(false);
  const {
    images: { iconChangeActive2 },
  } = useAppContext();

  const changeIngredient = async (event) => {
    if (event) {
      event.stopPropagation();
    }
    setPreloadInside(true);
    const replacement = {
      productAmountId: productAmountId,
      replacementId: replacementId,
      key: productKey,
      name: name,
      measurements: measurements,
    };
    await replaceProduct.replace(replacement);
    setPreloadInside(false);
    replaceProductSuccess();
  };

  return (
    <>
      <li onClick={(event) => changeIngredient(event)} data-test="replace-product">
        <MeasurementUnits measurements={measurements} />
        <span className="stay-together">
          <button type="button" className="btn-change">
            <img className="img-fluid" src={iconChangeActive2} alt="" />
          </button>
        </span>
        {name}
      </li>
      {preloadInside ? <Loader fixed="no" /> : ''}
    </>
  );
};

export default DayPlanIngredientReplacement;
